// Copyright (c) 2021 WiseTime. All rights reserved.

// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file wisetime/user/notification/v4/notification.proto (package wisetime.user.notification.v4, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file wisetime/user/notification/v4/notification.proto.
 */
export const file_wisetime_user_notification_v4_notification: GenFile = /*@__PURE__*/
  fileDesc("CjB3aXNldGltZS91c2VyL25vdGlmaWNhdGlvbi92NC9ub3RpZmljYXRpb24ucHJvdG8SHXdpc2V0aW1lLnVzZXIubm90aWZpY2F0aW9uLnY0IksKGExpc3ROb3RpZmljYXRpb25zUmVxdWVzdBIvCgNhcHAYASABKA4yIi53aXNldGltZS51c2VyLm5vdGlmaWNhdGlvbi52NC5BcHAiXwoZTGlzdE5vdGlmaWNhdGlvbnNSZXNwb25zZRJCCg1ub3RpZmljYXRpb25zGAEgAygLMisud2lzZXRpbWUudXNlci5ub3RpZmljYXRpb24udjQuTm90aWZpY2F0aW9uIvoBCgxOb3RpZmljYXRpb24SCgoCaWQYASABKAkSDwoHc2l0ZV9pZBgCIAEoCRJOChJsb2NhbGl6ZWRfY29udGVudHMYAyADKAsyMi53aXNldGltZS51c2VyLm5vdGlmaWNhdGlvbi52NC5Ob3RpZmljYXRpb25Db250ZW50EkwKEWFjdGlvbnNfYXZhaWxhYmxlGAQgAygOMjEud2lzZXRpbWUudXNlci5ub3RpZmljYXRpb24udjQuTm90aWZpY2F0aW9uQWN0aW9uEi8KC2NyZWF0ZV90aW1lGAUgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcCJgChNOb3RpZmljYXRpb25Db250ZW50Eg4KBmxvY2FsZRgBIAEoCRINCgV0aXRsZRgCIAEoCRIMCgRib2R5GAMgASgJEhwKFHByaW1hcnlfYWN0aW9uX2xhYmVsGAQgASgJInQKFkFja05vdGlmaWNhdGlvblJlcXVlc3QSFwoPbm90aWZpY2F0aW9uX2lkGAEgASgJEkEKBmFjdGlvbhgCIAEoDjIxLndpc2V0aW1lLnVzZXIubm90aWZpY2F0aW9uLnY0Lk5vdGlmaWNhdGlvbkFjdGlvbiIrChdBY2tOb3RpZmljYXRpb25SZXNwb25zZRIQCghvcGVuX3VybBgBIAEoCSosCgNBcHASEwoPQVBQX1VOU1BFQ0lGSUVEEAASEAoMV0VCX1RJTUVMSU5FEAEqWgoSTm90aWZpY2F0aW9uQWN0aW9uEiMKH05PVElGSUNBVElPTl9BQ1RJT05fVU5TUEVDSUZJRUQQABILCgdESVNNSVNTEAESEgoOUFJJTUFSWV9BQ1RJT04QAjKhAgoTTm90aWZpY2F0aW9uU2VydmljZRKGAQoRTGlzdE5vdGlmaWNhdGlvbnMSNy53aXNldGltZS51c2VyLm5vdGlmaWNhdGlvbi52NC5MaXN0Tm90aWZpY2F0aW9uc1JlcXVlc3QaOC53aXNldGltZS51c2VyLm5vdGlmaWNhdGlvbi52NC5MaXN0Tm90aWZpY2F0aW9uc1Jlc3BvbnNlEoABCg9BY2tOb3RpZmljYXRpb24SNS53aXNldGltZS51c2VyLm5vdGlmaWNhdGlvbi52NC5BY2tOb3RpZmljYXRpb25SZXF1ZXN0GjYud2lzZXRpbWUudXNlci5ub3RpZmljYXRpb24udjQuQWNrTm90aWZpY2F0aW9uUmVzcG9uc2VCQwolY29tLndpc2V0aW1lLmFwaS51c2VyLm5vdGlmaWNhdGlvbi52NEIYTm90aWZpY2F0aW9uU2VydmljZVByb3RvUAFiBnByb3RvMw", [file_google_protobuf_timestamp]);

/**
 * @generated from message wisetime.user.notification.v4.ListNotificationsRequest
 */
export type ListNotificationsRequest = Message<"wisetime.user.notification.v4.ListNotificationsRequest"> & {
  /**
   * The app that is requesting notifications to be shown to the user.
   *
   * @generated from field: wisetime.user.notification.v4.App app = 1;
   */
  app: App;
};

/**
 * Describes the message wisetime.user.notification.v4.ListNotificationsRequest.
 * Use `create(ListNotificationsRequestSchema)` to create a new message.
 */
export const ListNotificationsRequestSchema: GenMessage<ListNotificationsRequest> = /*@__PURE__*/
  messageDesc(file_wisetime_user_notification_v4_notification, 0);

/**
 * @generated from message wisetime.user.notification.v4.ListNotificationsResponse
 */
export type ListNotificationsResponse = Message<"wisetime.user.notification.v4.ListNotificationsResponse"> & {
  /**
   * @generated from field: repeated wisetime.user.notification.v4.Notification notifications = 1;
   */
  notifications: Notification[];
};

/**
 * Describes the message wisetime.user.notification.v4.ListNotificationsResponse.
 * Use `create(ListNotificationsResponseSchema)` to create a new message.
 */
export const ListNotificationsResponseSchema: GenMessage<ListNotificationsResponse> = /*@__PURE__*/
  messageDesc(file_wisetime_user_notification_v4_notification, 1);

/**
 * @generated from message wisetime.user.notification.v4.Notification
 */
export type Notification = Message<"wisetime.user.notification.v4.Notification"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Related site (team). If empty, this notification is relevant irrespective of the team.
   *
   * @generated from field: string site_id = 2;
   */
  siteId: string;

  /**
   * The notification content, translated in the locales that we support.
   * There must be at least one localized content. The client may default to the first
   * localized content if the locale that it prefers isn't in the list.
   *
   * @generated from field: repeated wisetime.user.notification.v4.NotificationContent localized_contents = 3;
   */
  localizedContents: NotificationContent[];

  /**
   * @generated from field: repeated wisetime.user.notification.v4.NotificationAction actions_available = 4;
   */
  actionsAvailable: NotificationAction[];

  /**
   * @generated from field: google.protobuf.Timestamp create_time = 5;
   */
  createTime?: Timestamp;
};

/**
 * Describes the message wisetime.user.notification.v4.Notification.
 * Use `create(NotificationSchema)` to create a new message.
 */
export const NotificationSchema: GenMessage<Notification> = /*@__PURE__*/
  messageDesc(file_wisetime_user_notification_v4_notification, 2);

/**
 * @generated from message wisetime.user.notification.v4.NotificationContent
 */
export type NotificationContent = Message<"wisetime.user.notification.v4.NotificationContent"> & {
  /**
   * The locale should be in the IETF BCP 47 Language Tag format. E.g. en-AU.
   *
   * @generated from field: string locale = 1;
   */
  locale: string;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: string body = 3;
   */
  body: string;

  /**
   * @generated from field: string primary_action_label = 4;
   */
  primaryActionLabel: string;
};

/**
 * Describes the message wisetime.user.notification.v4.NotificationContent.
 * Use `create(NotificationContentSchema)` to create a new message.
 */
export const NotificationContentSchema: GenMessage<NotificationContent> = /*@__PURE__*/
  messageDesc(file_wisetime_user_notification_v4_notification, 3);

/**
 * @generated from message wisetime.user.notification.v4.AckNotificationRequest
 */
export type AckNotificationRequest = Message<"wisetime.user.notification.v4.AckNotificationRequest"> & {
  /**
   * @generated from field: string notification_id = 1;
   */
  notificationId: string;

  /**
   * @generated from field: wisetime.user.notification.v4.NotificationAction action = 2;
   */
  action: NotificationAction;
};

/**
 * Describes the message wisetime.user.notification.v4.AckNotificationRequest.
 * Use `create(AckNotificationRequestSchema)` to create a new message.
 */
export const AckNotificationRequestSchema: GenMessage<AckNotificationRequest> = /*@__PURE__*/
  messageDesc(file_wisetime_user_notification_v4_notification, 4);

/**
 * @generated from message wisetime.user.notification.v4.AckNotificationResponse
 */
export type AckNotificationResponse = Message<"wisetime.user.notification.v4.AckNotificationResponse"> & {
  /**
   * If set, the client should open this URL when it receives the response.
   *
   * @generated from field: string open_url = 1;
   */
  openUrl: string;
};

/**
 * Describes the message wisetime.user.notification.v4.AckNotificationResponse.
 * Use `create(AckNotificationResponseSchema)` to create a new message.
 */
export const AckNotificationResponseSchema: GenMessage<AckNotificationResponse> = /*@__PURE__*/
  messageDesc(file_wisetime_user_notification_v4_notification, 5);

/**
 * @generated from enum wisetime.user.notification.v4.App
 */
export enum App {
  /**
   * @generated from enum value: APP_UNSPECIFIED = 0;
   */
  APP_UNSPECIFIED = 0,

  /**
   * @generated from enum value: WEB_TIMELINE = 1;
   */
  WEB_TIMELINE = 1,
}

/**
 * Describes the enum wisetime.user.notification.v4.App.
 */
export const AppSchema: GenEnum<App> = /*@__PURE__*/
  enumDesc(file_wisetime_user_notification_v4_notification, 0);

/**
 * @generated from enum wisetime.user.notification.v4.NotificationAction
 */
export enum NotificationAction {
  /**
   * @generated from enum value: NOTIFICATION_ACTION_UNSPECIFIED = 0;
   */
  NOTIFICATION_ACTION_UNSPECIFIED = 0,

  /**
   * @generated from enum value: DISMISS = 1;
   */
  DISMISS = 1,

  /**
   * @generated from enum value: PRIMARY_ACTION = 2;
   */
  PRIMARY_ACTION = 2,
}

/**
 * Describes the enum wisetime.user.notification.v4.NotificationAction.
 */
export const NotificationActionSchema: GenEnum<NotificationAction> = /*@__PURE__*/
  enumDesc(file_wisetime_user_notification_v4_notification, 1);

/**
 * Service for showing notifications to users. Supports multiple locales.
 * Initial use case: Request user authentication after another team member has created a new connector.
 *
 * Resources of the Notification service API include:
 *
 * - user/notifications/*
 *
 * Calls need to be authenticated with the user's ID token.
 *
 * @generated from service wisetime.user.notification.v4.NotificationService
 */
export const NotificationService: GenService<{
  /**
   * List all notifications for a user.
   *
   * @generated from rpc wisetime.user.notification.v4.NotificationService.ListNotifications
   */
  listNotifications: {
    methodKind: "unary";
    input: typeof ListNotificationsRequestSchema;
    output: typeof ListNotificationsResponseSchema;
  },
  /**
   * Acknowledge a notification
   * User has the option for dismissal or taking the action depending on the type (see below)
   *
   * @generated from rpc wisetime.user.notification.v4.NotificationService.AckNotification
   */
  ackNotification: {
    methodKind: "unary";
    input: typeof AckNotificationRequestSchema;
    output: typeof AckNotificationResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_wisetime_user_notification_v4_notification, 0);

